<div class="order-ticket-cont">
  <app-qr-data-card
    [header]="getHeaderText()"
    [footer]="env.platform"
    [qrData]="orderTicket.uuid"
    [logo]="env.logoAsset"
    [data]="orderTicket.ticketNumber"
    [loggedUser]="loggedUser"
    [isBackSide]="false"
    [allowFlip]="false"
    [brandColors]="false"
    [disabled]="!isTicketUsable()"
    [notClaimed]="isNotClaimed"
  ></app-qr-data-card>

  <swiper-container
    appSwiper
    #swiperElement
    [config]="swiperActionsConfig"
    #swiperRef
    class="ticket-actions-swiper"
  >
    @for (ticketAction of ticketActions; track $index) {
      @if (shouldShowTicketAction(ticketAction)) {
        <swiper-slide>
          <app-ticket-action
            [label]="GenericAction.getDisplayName(ticketAction)"
            [icon]="GenericAction.getIcon(ticketAction)"
            [inProgress]="ticketActionInProgress === ticketAction"
            (click)="executeAction(ticketAction)"
          />
        </swiper-slide>
      }
    }
  </swiper-container>

  <div class="owner-cont">
    <div class="owner-header">
      {{ "APP.TICKETS_DASHBOARD.OWNER" | translate }}
    </div>
    <app-ticket-order-ticket-owner-card
      [ticket]="orderTicket"
      [event]="event"
      [status]="orderTicket.status"
      (forwardTicket)="forwardTicket()"
      (viewData)="viewData()"
    />
  </div>
  @if (showAdditionalData()) {
    <div class="additional-info">
      {{ "APP.TICKETS_DASHBOARD.ASSIGN_TICKET_DESCRIPTION" | translate }}
    </div>
  }
</div>
